import { API_DOMAIN, WALLET } from 'config/constants';
import { api } from 'lib/api';
import { checkStatus } from 'lib/helpers';
import { z } from 'zod';

export const zUserBalance = z.object({
	username: z.string(),
	balance: z.number(),
	points: z.number().optional(),
});

export type UserBalance = z.infer<typeof zUserBalance>;

const zUserBalanceResonse = z.object({
	success: z.boolean(),
	balance: zUserBalance,
});

type UserBalanceResponse = z.infer<typeof zUserBalanceResonse>;

export async function fetchUserBalance(username: string): Promise<UserBalance> {
	try {
		const response = await api.get<UserBalance>(`${API_DOMAIN}${WALLET}/user_balance/${username}`);

		if (!checkStatus(response)) {
			throw new Error('invalid credentials');
		}

		if (!zUserBalance.safeParse(response.data).success) {
			throw new Error('invalid response');
		}
		return response.data;
	} catch (error) {
		console.error(error);
		return { username, balance: 0 };
	}
}

export async function addUserBalance(username: string, balance: number): Promise<UserBalanceResponse> {
	try {
		const response = await api.patch<UserBalanceResponse>(
			`${API_DOMAIN}${WALLET}/user_balance/${username}/add/${balance}`
		);
		if (!checkStatus(response)) {
			throw new Error('invalid credentials');
		}
		return response.data;
	} catch (error) {
		console.error(error);
		return {
			balance: {
				username,
				balance: 0,
			},
			success: false,
		};
	}
}

export async function resetUserBalance(username: string): Promise<UserBalanceResponse> {
	try {
		const response = await api.delete<UserBalanceResponse>(`${API_DOMAIN}${WALLET}/user_balance/${username}`);
		if (!checkStatus(response)) {
			throw new Error('invalid credentials');
		}
		return response.data;
	} catch (error) {
		console.error(error);
		return {
			balance: {
				username,
				balance: 0,
			},
			success: false,
		};
	}
}
